import { getLanguage as getInterfaceLanguage } from '@/utils/i18n';
export type NumericInputSize = 'sm' | 'md' | 'lg';
export type NumericFormat = 'integer' | 'decimal' | 'time' | 'currency';
export type ValidationState = 'default' | 'error' | 'success';

export interface BaseNumericProps {
  min?: number;
  max?: number;
  step?: number;
  disabled?: boolean;
}

export interface NumericFieldConfig {
  id: string;
  label: string;
  value: number;
  tooltip?: string;
  min?: number;
  max?: number;
  step?: number;
  suffix?: string;
}

export const sizeClasses = {
  sm: { input: 'h-6 w-16 text-xs', button: 'h-5 w-5', icon: 'h-3 w-3' },
  md: { input: 'h-7 w-20 text-sm', button: 'h-6 w-6', icon: 'h-3.5 w-3.5' },
  lg: { input: 'h-8 w-24 text-base', button: 'h-7 w-7', icon: 'h-4 w-4' },
};

export const stepperButtonClasses = {
  circle: {
    sm: 'h-6 w-6 rounded-full',
    md: 'h-8 w-8 rounded-full',
    lg: 'h-10 w-10 rounded-full',
  },
  square: {
    sm: 'h-6 w-6 rounded-md',
    md: 'h-8 w-8 rounded-md',
    lg: 'h-10 w-10 rounded-md',
  },
};

export const formatValue = (
  value: number,
  format: NumericFormat,
  precision: number = 1
): string => {
  switch (format) {
    case 'integer':
      return Math.round(value).toString();
    case 'decimal':
      return value.toFixed(precision);
    case 'time':
      const mins = Math.floor(value / 60);
      const secs = Math.round(value % 60);
      return mins > 0 ? `${mins}:${secs.toString().padStart(2, '0')}` : `${secs}`;
    case 'currency':
      return value.toLocaleString(getInterfaceLanguage(), { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    default:
      return value.toFixed(precision);
  }
};

export const validateRange = (value: number, min?: number, max?: number): boolean => {
  if (min !== undefined && value < min) return false;
  if (max !== undefined && value > max) return false;
  return true;
};
